<template>
  <header>
    <h1>
      <a href="https://www.gabia.com">
        <img src="https://static.gabia.com/www/common/img/logo.svg" alt=""
      /></a>
      <a href="/"><span class="service-name">리셀러</span></a>
    </h1>
    <nav>
      <a
        href="/"
        class="menu"
        :class="
          this.$route.name === 'SalesLookup' ? 'router-link-exact-active' : ''
        "
        >실적조회</a
      >
      <a
        href="/calculate-manage"
        class="menu"
        :class="
          this.$route.name === 'CalculateManage'
            ? 'router-link-exact-active'
            : ''
        "
        >정산관리</a
      >
    </nav>
    <div class="logout-area">
      <a
        href="/reseller-info"
        :class="
          this.$route.name === 'ResellerInfo' ? 'router-link-exact-active' : ''
        "
        >리셀러 정보</a
      >
      <span class="bar"></span>
      <b>{{ headerInfo.hanorg }}</b
      >님
      <a
        href="https://www.gabia.com/login/logout.php?origin_site=https://www.gabia.com"
        class="m-l-10"
        >로그아웃
        <i class="far fa-sign-out"></i>
      </a>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      headerInfo: []
    };
  },

  async mounted() {
    await this.$_getResellerName();
  },

  methods: {
    async $_getResellerName() {
      await this.axios
        .get('front/reseller')
        .then(response => {
          if (response.status == 200) {
            this.headerInfo = response.data.data[0].client;
          } else {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
          }
        })
        .catch(error => {
          if (error.status == '401') {
            alert('승인된 리셀러만 관리툴을 이용할 수 있습니다');
            location.replace(
              `https://www.gabia.com/login/login_form.php?origin_site=https://reseller.gabia.com`
            );
          } else {
            console.log('reseller fetchData failed', error);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.m-l-10 {
  margin-left: 10px;
}
</style>
